import { Injectable } from '@angular/core';
import { Api } from '../../contracts/classes/api.class';
import { Observable } from 'rxjs';
import { IResponse } from '../../contracts/models/response.model';
import { CreateTypeComunicacionDTO, TypeComunicacion, updateOrderTypeComunicacionDTO, UpdateTypeComunicacionDTO } from '../../contracts/models/type-comunicacion.model';

@Injectable({
  providedIn: 'root'
})
export class TypeComunicacionService extends Api {

  getAll(): Observable<IResponse<TypeComunicacion[]>> {
    return this.http.get<IResponse<TypeComunicacion[]>>(`${this.url}/tipoComunicacion`);
  }

  create(createTypeEmailDTO: CreateTypeComunicacionDTO): Observable<IResponse<TypeComunicacion>> {
    return this.http.post<IResponse<TypeComunicacion>>(`${this.url}/tipoComunicacion`, createTypeEmailDTO);
  }

  update(UpdateTypeComunicacionDTO: UpdateTypeComunicacionDTO): Observable<IResponse<TypeComunicacion>> {
    return this.http.put<IResponse<TypeComunicacion>>(`${this.url}/tipoComunicacion/${UpdateTypeComunicacionDTO.id}`, UpdateTypeComunicacionDTO);
  }

  delete(id: number): Observable<IResponse<TypeComunicacion>> {
    return this.http.delete<IResponse<TypeComunicacion>>(`${this.url}/tipoComunicacion/${id}`);
  }

  updateOrder(updateOrderTypeComunicacionDTO: updateOrderTypeComunicacionDTO[]): Observable<IResponse<TypeComunicacion[]>> {
    return this.http.put<IResponse<TypeComunicacion[]>>(`${this.url}/tipoComunicacion/data/updateOrder`, {
      tipoComunicaciones: updateOrderTypeComunicacionDTO
    });
  }
}
